'use client';

import React__default, { useState, useEffect } from 'react';
import { filterHTMLTag } from '../Utils/helpers.js';
import { QuillSnowCss, TextEditorQuillWrapper, LimitCharacter } from './TextEditorQuill.css.js';
import translations from './translate.js';

var TextEditorQuill = function (props) {
    var _a = props.lang, lang = _a === void 0 ? 'vi' : _a, content = props.content, placeholder = props.placeholder, _b = props.limit, limit = _b === void 0 ? -1 : _b, _c = props.maxHeight, maxHeight = _c === void 0 ? 150 : _c, customRef = props.customRef, textEditor = props.textEditor, _d = props.isShowLimitLeft, isShowLimitLeft = _d === void 0 ? true : _d, onChange = props.onChange;
    var contentFilter = filterHTMLTag(content);
    var _e = useState(limit - contentFilter.length), remainingChars = _e[0], setRemainingChars = _e[1];
    var t = function (text) {
        if (lang === 'en') {
            return text;
        }
        else {
            return translations[text];
        }
    };
    var onEditorTextChange = function () {
        var content = customRef.current.querySelector('.ql-editor').innerHTML;
        // Check limit
        if (limit > -1) {
            var remainingChars_1 = limit - filterHTMLTag(content).length;
            setRemainingChars(remainingChars_1);
            if (remainingChars_1 < 0) {
                return;
            }
        }
        onChange && onChange(content);
    };
    var renderRemainCharacter = function () {
        if (limit === -1) {
            return React__default.createElement(React__default.Fragment, null);
        }
        if (remainingChars >= 0) {
            return (React__default.createElement(LimitCharacter, { isShowLimitLeft: isShowLimitLeft },
                remainingChars,
                " ",
                t('characters remaining')));
        }
        else {
            return React__default.createElement(LimitCharacter, { isMax: true }, t('You have entered too many characters'));
        }
    };
    useEffect(function () {
        if (customRef === undefined || customRef === null) {
            return;
        }
        if (customRef.current === undefined || customRef.current === null) {
            return;
        }
        if (customRef.current.__quill === undefined || customRef.current.__quill === null) {
            return;
        }
        if (textEditor === undefined || textEditor === null) {
            return;
        }
        // Set default value to editor
        var delta = customRef.current.__quill.clipboard.convert(content);
        customRef.current.__quill.setContents(delta, 'silent');
        // Add event listen on change
        customRef.current.__quill.on('text-change', onEditorTextChange);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customRef, textEditor]);
    if (typeof window === undefined || typeof document === undefined) {
        return React__default.createElement(React__default.Fragment, null);
    }
    return (React__default.createElement(QuillSnowCss, null,
        React__default.createElement(TextEditorQuillWrapper, { maxHeight: maxHeight, placeholder: placeholder },
            React__default.createElement("div", { className: 'snow', ref: customRef, defaultValue: content }),
            renderRemainCharacter())));
};

export { TextEditorQuill as default };
//# sourceMappingURL=index.js.map
